























import { defineComponent } from "@vue/composition-api";
import { Location } from "vue-router";
import { Follower } from "@scrile/api-provider/dist/api/FollowingsProvider";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { getProfileUrl } from "@/lib/urlHelpers";
import BaseAvatar from "@/components/BaseAvatar";
import ListItem from "@/components/ListItem";
import { FollowersMap } from "../../types";
import FollowButtonController from "../FollowButtonController";

export default defineComponent({
  name: "FollowersItem",
  components: { FollowButtonController, BaseAvatar, ListItem },
  props: {
    follower: { type: Object as () => Follower, required: true },
    authUserId: { type: String, required: true },
    isFollowingPage: { type: Boolean, required: true },
    authorFollowings: { type: Object as () => FollowersMap, required: true },
    isAuthor: { type: Boolean, required: true },
  },
  computed: {
    followerData(): UserPublicData | null {
      return this.isFollowingPage ? this.follower.user : this.follower.follower;
    },
    profileUrl(): Location | null {
      return this.followerData ? getProfileUrl(this.followerData) : null;
    },
    screenName(): string {
      return this.followerData?.screenName ?? "";
    },
  },
});
